/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';
import { ModelType } from 'src/luis/types/ModelType';

const messages = defineMessages({
    regex: {
        id: 'luis.entities.translatedText.regex',
        defaultMessage: 'regex'
    },
    patternAny: {
        id: 'luis.entities.translatedText.patternAny',
        defaultMessage: 'Pattern.Any'
    },
    list: {
        id: 'luis.entities.translatedText.list',
        defaultMessage: 'list'
    },
    composite: {
        id: 'luis.entities.translatedText.composite',
        defaultMessage: 'composite'
    },
    hierarchical: {
        id: 'luis.entities.translatedText.hierarchical',
        defaultMessage: 'hierarchical'
    },
    prebuilt: {
        id: 'luis.entities.translatedText.prebuilt',
        defaultMessage: 'prebuilt'
    },
    simple: {
        id: 'luis.entities.translatedText.simple',
        defaultMessage: 'machine learned'
    },
    role: {
        id: 'luis.entities.translatedText.role',
        defaultMessage: 'role'
    }
});

export const getTranslatedEntityType = (modelType: ModelType, localize: ReactIntl.InjectedIntl['formatMessage']) => {
    switch (modelType) {
        case ModelType.Composite:
            return localize(messages.composite);
        case ModelType.HierarchicalChild:
        case ModelType.Hierarchical:
            return localize(messages.hierarchical);
        case ModelType.List:
            return localize(messages.list);
        case ModelType.PatternAny:
            return localize(messages.patternAny);
        case ModelType.Prebuilt:
            return localize(messages.prebuilt);
        case ModelType.Regex:
            return localize(messages.regex);
        case ModelType.Simple:
            return localize(messages.simple);
        case ModelType.Role:
            return localize(messages.role);
        default:
            return '';
    }
};
